import React, { useEffect, useState } from 'react';
import {
  Drawer,
  AppBar,
  Toolbar,
  IconButton,
  Box,
  CssBaseline,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Avatar,
  Collapse,
} from '@mui/material';
import {
  MenuOpen as MenuOpenIcon,
  Close as CloseIcon,
  Dashboard as DashboardIcon,
  AccountCircle as AccountCircleIcon,
  People as PeopleIcon,
  Inventory2 as ProductsIcon,
  CardGiftcard as GiftIcon,
  Link as LinkIcon,
  ShoppingCart as CartIcon,
  AssignmentInd as RoleIcon,
  Notifications as NotificationIcon,
  MonetizationOn as CreditIcon,
  LocalActivity,
  Assignment,
  ExpandLess,
  ExpandMore,
  Person as PersonIcon,
  Group as GroupIcon,
} from '@mui/icons-material';

import Logo from '../assets/images/logo.svg';
import MGlo from '../assets/images/Button.svg';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import routes from './Routes';
import { getMeDetails } from '../components/actionCreator';

const drawerWidthOpen = 240;
const drawerWidthClosed = 60;

function DashboardLayout() {
  const [open, setOpen] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [ordersOpen, setOrdersOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const toggleDrawer = () => setOpen(!open);
  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const [userData, setUser] = useState('');

  const handleLogout = () => {
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
    handleMenuClose();
    navigate('/login');
  };
  const getMe = () => {
    getMeDetails(callback => {
      setUser(callback)

    })
  }
  useEffect(() => {
    getMe()
  }, [])
  const isActive = (path) => location.pathname === path;

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />

      {/* AppBar */}
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: '#fff' }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={toggleDrawer} sx={{ mr: 2, color: '#2A2A2A' }}>
            {open ? <CloseIcon /> : <MenuOpenIcon />}
          </IconButton>
          <div>
            <img src={Logo} alt="Logo" style={{ height: 40 }} />
            &nbsp;
            <img src={MGlo} alt="MGlo" style={{ height: 40 }} />
          </div>
          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleMenuOpen} sx={{ color: '#2A2A2A' }}>
            {console.log(userData)}
            <img
              src={userData?.[0]?.picture || ''}
              alt="User"
              style={{ height: 40, borderRadius: '25px',width:40 }}
            />

          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            <MenuItem onClick={() => navigate(routes.PROFILE)}>Profile</MenuItem>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      {/* Drawer */}
      <Drawer
        variant="permanent"
        sx={{
          width: open ? drawerWidthOpen : drawerWidthClosed,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: open ? drawerWidthOpen : drawerWidthClosed,
            boxSizing: 'border-box',
            transition: 'width 0.3s',
          },
        }}
      >
        <Toolbar />
        <Box sx={{ overflow: 'hidden' }}>
          <List>
            <SidebarItem icon={<DashboardIcon />} text="Dashboard" path={routes.DASHBOARD} />
            <SidebarItem icon={<ProductsIcon />} text="Products Stock" path={routes.PRODUCTS} />

            {/* Orders section with nested items */}
            <ListItem button onClick={() => setOrdersOpen(!ordersOpen)}
              sx={{
                backgroundColor: isActive(routes.ORDERS) ? '#2A2A2A' : 'transparent',
                color: isActive(routes.ORDERS) ? '#fff' : 'inherit',
                '&:hover': {
                  backgroundColor: isActive(routes.ORDERS) ? '#2A2A2A' : '#f0f0f0',
                },
              }}
            >
              <ListItemIcon sx={{ color: isActive(routes.ORDERS) ? '#fff' : 'inherit' }}>
                <CartIcon />
              </ListItemIcon>
              {open && <ListItemText primary="Orders" />}
              {open && (ordersOpen ? <ExpandLess /> : <ExpandMore />)}
            </ListItem>

            <Collapse in={ordersOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  sx={{ pl: 4 }}
                  onClick={() => navigate(routes.CREATORS_CART)}
                >
                  <ListItemIcon><PersonIcon /></ListItemIcon>
                  {open && <ListItemText primary="Creator" />}
                </ListItem>
                <ListItem
                  button
                  sx={{ pl: 4 }}
                  onClick={() => navigate(routes.CUSTOMER_CART)}
                >
                  <ListItemIcon><GroupIcon /></ListItemIcon>
                  {open && <ListItemText primary="Customer" />}
                </ListItem>
              </List>
            </Collapse>

            <SidebarItem icon={<GiftIcon />} text="Campaign" path={routes.CAMPAIGN} />
            <SidebarItem icon={<CreditIcon />} text="Finances" path={routes.FINANCES} />
            <SidebarItem icon={<PeopleIcon />} text="Activity" path={routes.ACTIVITY} />
            <SidebarItem icon={<LocalActivity />} text="Game Contest" path={routes.GAME_CONTEST} />
            <SidebarItem icon={<LinkIcon />} text="Ticket" path={routes.TICKET} />
            <SidebarItem icon={<Assignment />} text="Rapport" path={routes.RAPPORT} />
            <SidebarItem icon={<RoleIcon />} text="Briefs & Rules" path={routes.BRIEFS_RULES} />
            <SidebarItem icon={<NotificationIcon />} text="API Connect" path={routes.API_CONNECT} />
            <SidebarItem icon={<AccountCircleIcon />} text="About" path={routes.ABOUT} />
          </List>
        </Box>
      </Drawer>

      {/* Main content */}
      <Box component="main" sx={{ flexGrow: 1, p: 3, mt: 8, background: '#f2f5f9', minHeight: '100vh' }}>
        <Outlet />
      </Box>
    </Box>
  );

  // SidebarItem Component
  function SidebarItem({ icon, text, path }) {
    const active = isActive(path);
    return (
      <ListItem
        button
        onClick={() => navigate(path)}
        sx={{
          backgroundColor: active ? '#2A2A2A' : 'transparent',
          color: active ? '#fff' : 'inherit',
          '&:hover': {
            backgroundColor: active ? '#2A2A2A' : '#f0f0f0',
          },
        }}
      >
        <ListItemIcon sx={{ color: active ? '#fff' : 'inherit' }}>{icon}</ListItemIcon>
        {open && <ListItemText primary={text} />}
      </ListItem>
    );
  }
}

export default DashboardLayout;
